export function buildReportExcerptUrl(reportId, excerpt) {
    if (!reportId) {
        return '';
    }
    let trimmed = excerpt?.trim();
    if (!trimmed) {
        return `/products/${reportId}`;
    }
    if (trimmed.length > 150) {
        trimmed = trimmed.slice(0, 150).replace(/\s+\S*$/, '').trim() || trimmed.slice(0, 150);
    }
    const q = `?q=${encodeURIComponent(trimmed)}`;
    return `/products/${reportId}${q}`;
}

/** Opens the report in a new tab; ?q= scrolls the products page to the matching excerpt. */
export function openReportExcerptInNewTab(reportId, excerpt) {
    const url = buildReportExcerptUrl(reportId, excerpt);
    if (!url || typeof window === 'undefined') {
        return;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
}
